"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getVersionInfo = exports.VersionImpl = void 0;
const DateUtil_1 = require("../util/DateUtil");
class VersionImpl {
    constructor(scmVersion, scmBranch, buildtime, pomVersion) {
        this.scmVersion = scmVersion;
        this.scmBranch = scmBranch;
        this.buildtime = buildtime;
        this.pomVersion = pomVersion;
    }
    getScmVersion() {
        return this.scmVersion;
    }
    getScmBranch() {
        return this.scmBranch;
    }
    getBuildtime() {
        return this.buildtime;
    }
    getPomVersion() {
        return this.pomVersion;
    }
}
exports.VersionImpl = VersionImpl;
function getVersionInfo(version) {
    return `${version.getPomVersion()}, bygget: ${(0, DateUtil_1.formatDateTime)(version.getBuildtime())}`;
}
exports.getVersionInfo = getVersionInfo;
//# sourceMappingURL=Version.js.map